import { gozokiApi, gozokiApiWithAuth } from '../gozokiApi'

import {
  type StoreReapproCategoryAlgorithm,
  type Category,
  type InternalCategory,
  type ReapproCategory,
} from '@gozoki/api-types'

// Fetch one category
export const fetchCategory = async (id: number) => {
  const response = await gozokiApi.get<Category>(`/categories/${id}`)
  return response.data
}

export const fetchActivesAndUsedCategories = async (storeId: number) => {
  const response = await gozokiApi.get<Category[]>(`stores/${storeId}/categories/actives-and-used`)
  return response.data
}

// Fetch all categories
export const fetchCategories = async () => {
  const response = await gozokiApi.get<Category[]>('/categories')
  return response.data
}

// Fetch all internal categories
export const fetchInternalCategories = async () => {
  const response = await gozokiApiWithAuth.get<InternalCategory[]>('/internal-categories')
  return response.data
}

export const fetchMultipleCategories = async (ids: number[]) => {
  const data = { ids }
  const response = await gozokiApiWithAuth.post<Category[]>('/categories/show-multiple', data)
  return response.data
}

export const fetchReapproCategories = async () => {
  const response = await gozokiApiWithAuth.get<ReapproCategory[]>('/reappro-categories')
  return response.data
}

export const fetchReapproCategoryAlgorithms = async () => {
  const response = await gozokiApiWithAuth.get<StoreReapproCategoryAlgorithm[]>(
    '/reappro-categories/algorithms',
  )
  return response.data
}
